module.exports = __webpack_public_path__ + "images/category_lp/camera/new/assessment_achievements/6_1b5eb5f10723fb86ef42632f608606fd.png";